import React, { useEffect, useState } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    Box,
    Typography,
    Grid,
    Card,
    Divider,
    CardContent,
    IconButton,
    Avatar,
    Chip,
    Button
} from "@mui/material";
import { RxCross2 } from "react-icons/rx";
import moment from "moment";
import StatusBadge from "components/badge/StatusBadge";
import ImageModal from "./ImageModal";

const ViewEHSFinding = (props) => {
    const { open, handleClose, rowData } = props;
    const [isShow, setIsShow] = useState(false);
    const [viewImage, setViewImage] = useState(null)
    const [title, setTitle] = useState("")

    const labelStyle = {
        fontSize: "14px",
        color: "#6b7280",
        display: "flex",
        alignItems: "center",
        gap: "4px",
    };

    const valueStyle = {
        fontSize: "15px",
        color: "#111827",
        fontWeight: 500,
        mt: 0.5,
    };

    const handleClick = (url, title) => {
        setViewImage(url)
        setTitle(title)
        setIsShow(true)
    }

    const handleCloseImage = () => {
        setViewImage(null);
        setTitle("")
        setIsShow(false)
    }

    return (
        <>
            <Dialog
                open={open}
                fullWidth
                maxWidth="lg"
                PaperProps={{
                    sx: {
                        borderTopLeftRadius: "5px",
                        borderTopRightRadius: "5px",
                        backgroundColor: "#FFFFFF",
                        width: "100%",
                        overflowX: "hidden"
                    },
                }}
                disableEscapeKeyDown
                onClose={(event, reason) => {
                    if (reason !== "backdropClick") {
                        handleClose();
                    }
                }}
            >
                <DialogTitle sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    borderBottom: "1px solid #ddd",
                    backgroundColor: "#ECECEC",
                    pb: 2,
                    pt: 3,
                    width: "100%",
                }}>
                    <Typography sx={{
                        fontWeight: 600,
                        fontSize: "27px",
                        lineHeight: "100%",
                        color: "#140F36",
                        fontFamily: "Outfit, sans-serif"
                    }}>
                        View EHS Details
                    </Typography>
                    <IconButton
                        aria-label="close"
                        onClick={() => handleClose()}
                        sx={(theme) => ({
                            position: "absolute",
                            right: 8,
                            top: 8,
                            color: theme.palette.grey[500],
                        })}
                    >
                        <RxCross2 style={{ fontSize: "30px", color: "#140F36" }} />
                    </IconButton>
                </DialogTitle>

                <DialogContent dividers>
                    <Grid container spacing={2}>

                        <Grid size={12}>
                            <Card
                                elevation={0}
                                sx={{
                                    borderRadius: "3px",
                                    border: "1px solid #e5e7eb",
                                    backgroundColor: "#fff",
                                    p: 2,
                                }}
                            >
                                {/* Header */}
                                <Box
                                    sx={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        mb: 1,
                                    }}
                                >
                                    <Typography sx={{ fontWeight: 600, fontSize: "16px" }}>
                                        EHS Information
                                    </Typography>
                                </Box>

                                <Divider sx={{ mb: 2 }} />

                                <CardContent sx={{ pt: 0 }}>
                                    <Grid container spacing={2}>
                                        {/* Risk-specific fields */}

                                        <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                            <Typography sx={labelStyle}>EHS Finding:</Typography>
                                            <Typography sx={valueStyle}>{rowData?.ehsFinding ?? "N/A"}</Typography>
                                        </Grid>
                                         <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                            <Typography sx={labelStyle}>Severity:</Typography>
                                            <Typography sx={valueStyle}>{rowData?.severity ?? "N/A"}</Typography>
                                        </Grid>

                                        <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                            <Typography sx={labelStyle}>Reported By:</Typography>
                                            <Typography sx={valueStyle}>{rowData?.reportedBy ?? "N/A"}</Typography>
                                        </Grid>

                                        <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                            <Typography sx={labelStyle}>Area:</Typography>
                                            <Typography sx={valueStyle}>{rowData?.area ?? "N/A"}</Typography>
                                        </Grid>

                                        <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                            <Typography sx={labelStyle}>Status Of Compliance:</Typography>
                                            <StatusBadge status={rowData?.statusOfCompliance} />
                                        </Grid>

                                        <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                            <Typography sx={labelStyle}>Location:</Typography>
                                            <Typography sx={valueStyle}>{rowData?.location ?? "N/A"}</Typography>
                                        </Grid>

                                        <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                            <Typography sx={labelStyle}>Contractor & Sub Contractor Involved:</Typography>
                                            <Typography sx={valueStyle}>{rowData?.contractorSubContractorInvolved ?? "N/A"}</Typography>
                                        </Grid>

                                        <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                            <Typography sx={labelStyle}>PTW Issued:</Typography>
                                            <Typography sx={valueStyle}>{rowData?.ptwIssued === true ? "Yes" : "No" ?? "N/A"}</Typography>
                                        </Grid>

                                        <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                            <Typography sx={labelStyle}>Category:</Typography>
                                            <Typography sx={valueStyle}>{rowData?.category ?? "N/A"}</Typography>
                                        </Grid>

                                        <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                            <Typography sx={labelStyle}>PTW Issued By:</Typography>
                                            <Typography sx={valueStyle}>{rowData?.ptwIssuedBy ?? "N/A"}</Typography>
                                        </Grid>

                                        <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                            <Typography sx={labelStyle}>Stop Work Recommended:</Typography>
                                            <Typography sx={valueStyle}>{rowData?.stopWorkRecommended === true ? "Yes" : "No" ?? "N/A"}</Typography>
                                        </Grid>

                                        <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                            <Typography sx={labelStyle}>Date:</Typography>
                                            <Typography sx={valueStyle}>
                                                {rowData?.dateTime ? moment.utc(rowData?.dateTime).format("DD MMM YYYY") : "N/A"}
                                            </Typography>
                                        </Grid>

                                        <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                            <Typography sx={labelStyle}>Target Closure Date:</Typography>
                                            <Typography sx={valueStyle}>
                                                {rowData?.targetClosureDate ? moment.utc(rowData?.targetClosureDate).format("DD MMM YYYY") : "N/A"}
                                            </Typography>
                                        </Grid>

                                        <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                            <Typography sx={labelStyle}>Action Owner:</Typography>
                                            <Typography sx={valueStyle}>{rowData?.actionOwner ?? "N/A"}</Typography>
                                        </Grid>

                                        <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                            <Typography sx={labelStyle}>Compliance Statement:</Typography>
                                            <Typography sx={valueStyle}>
                                                {rowData?.complianceStatement ?? "N/A"}
                                            </Typography>
                                        </Grid>

                                        <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                            <Typography sx={labelStyle}>Verified By:</Typography>
                                            <Typography sx={valueStyle}>
                                                {rowData?.verifiedBy ?? "N/A"}
                                            </Typography>
                                        </Grid>

                                        <Grid size={12}>
                                            <Typography sx={labelStyle}>Recommendation:</Typography>
                                            <Typography sx={{ ...valueStyle, whiteSpace: "pre-line" }}>{rowData?.recommendation ?? "N/A"}</Typography>
                                        </Grid>

                                        <Grid size={12}>
                                            <Typography sx={labelStyle}>Finding Photographs:</Typography>
                                            <Box display="flex" gap={1} flexWrap="wrap" mt={1}>
                                                {rowData?.findingPhotographs && rowData.findingPhotographs.length > 0 ? (
                                                    rowData.findingPhotographs.map((file, index) => (
                                                        <img
                                                            key={index}
                                                            src={file?.filePath}
                                                            alt="findingPhotographs"
                                                            width={240}
                                                            height={240}
                                                            style={{
                                                                objectFit: "cover",
                                                                borderRadius: 6,
                                                                border: "1px solid #ddd",
                                                                cursor: "pointer"
                                                            }}
                                                            onClick={() => handleClick(file?.filePath, "View Finding Photographs")}
                                                        />
                                                    ))
                                                ) : (
                                                    <Typography variant="body2" sx={{ ...valueStyle, whiteSpace: "pre-line" }}>N/A</Typography>
                                                )}
                                            </Box>
                                        </Grid>

                                        <Grid size={12}>
                                            <Typography sx={labelStyle}>Compliance Photographs:</Typography>
                                            <Box display="flex" gap={1} flexWrap="wrap" mt={1}>
                                                {rowData?.compliancePhotographs && rowData.compliancePhotographs.length > 0 ? (
                                                    rowData.compliancePhotographs.map((file, index) => (
                                                        <img
                                                            key={index}
                                                            src={file?.filePath}
                                                            alt="compliancePhotographs"
                                                            width={240}
                                                            height={240}
                                                            style={{
                                                                objectFit: "cover",
                                                                borderRadius: 6,
                                                                border: "1px solid #ddd",
                                                                cursor: "pointer"
                                                            }}
                                                            onClick={() => handleClick(file?.filePath, "View Compliance Photographs")}
                                                        />
                                                    ))
                                                ) : (
                                                    <Typography variant="body2" sx={{ ...valueStyle, whiteSpace: "pre-line" }}>N/A</Typography>
                                                )}
                                            </Box>
                                        </Grid>

                                    </Grid>
                                </CardContent>
                            </Card>
                        </Grid>
                    </Grid>
                </DialogContent>
            </Dialog>
            <ImageModal
                open={isShow}
                handleClose={handleCloseImage}
                fileUrl={viewImage}
                title={title}
            />
        </>
    );
};

export default ViewEHSFinding;